const _ = require("lodash");
const EventEmitter = require("events");
const ContainerSize = require("../util/ContainerSize");

// This file implements the watching of the window resize event and the
// recomputing of the container size and position. It also allows listening to
// these changes. It will cause errors if used from within server rendering.

const resizeEmitter = new EventEmitter();
// Test overview has over 100 components using withContainerDims, so this
// needs to be high. But leak detection is useful.
resizeEmitter.setMaxListeners(1000);

// getTopSize can be overwritten by exported setTopSizeGetter function.
let getTopSize = function() {
	return {
		width: window.innerWidth,
		height: window.innerHeight,
	};
};
const setTopSizeGetter = f => {
	getTopSize = f;
};

const recomputeDims = function() {
	const topSize = getTopSize();
	const windowWidth = topSize.width;
	const windowHeight = topSize.height;
	const {width, height} = ContainerSize.getContainerSizeFromWindow(
		windowWidth,
		windowHeight
	);
	return {
		width: width,
		height: height,
		left: Math.max(Math.floor((topSize.width - width) / 2), 0),
		top: Math.max(Math.floor((topSize.height - height) / 2), 0),
		windowWidth,
		windowHeight,
	};
};

// We want to return the same dims object from getCurrentDims and the resize
// listener whenever possible. These module-level variables help do that.
let lastComputedDims = null;
let startedResizeListener = false;

const startResizeListener = function() {
	if (startedResizeListener || typeof window === "undefined") {
		return;
	}
	startedResizeListener = true;

	window.addEventListener(
		"resize",
		_.debounce(() => {
			lastComputedDims = recomputeDims();
			resizeEmitter.emit("resize", lastComputedDims);
		}, 200)
	);
	lastComputedDims = recomputeDims();
};

// Get the current dimensions of the container. If the window is not defined,
// return empty dimensions.
const getCurrentDims = function() {
	startResizeListener();
	return lastComputedDims ?? getEmptyDims();
};

const addDimsListener = function(f) {
	startResizeListener();
	resizeEmitter.addListener("resize", f);
};
const removeDimsListener = function(f) {
	f && resizeEmitter.removeListener("resize", f);
};

const getEmptyDims = function() {
	return {
		width: 0,
		height: 0,
		left: 0,
		top: 0,
		windowWidth: 0,
		windowHeight: 0,
	};
};

module.exports = {
	setTopSizeGetter,
	getCurrentDims,
	addDimsListener,
	removeDimsListener,
	getEmptyDims,
};
